import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LiveEvent, LiveEventBet } from 'types/LiveEvent';
import { filterMarkets } from 'helpers/marketSearch';
import {
  MarketSearch,
  MarketSearchEmpty,
  MarketSearchToggle,
} from 'components/MarketSearch/MarketSearch';
import { useOfferSections } from 'helpers/offerLayout';
import { OtherBets } from './OtherBets';
import { GroupedOtherBets } from './GroupedOtherBets';
import styles from './GroupedOtherBets.module.css';

/** A live match's markets with the magnifier that opens the search above. */
export const SearchableOtherBets = ({
  bets,
  match,
}: {
  bets: LiveEventBet[];
  match: LiveEvent;
}) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const layout = useOfferSections(match.sportId, 'live');
  const found = filterMarkets(bets, query, t);
  // A sport whose live offer the staff arranged reads in sections, as
  // betbigwin's live matches do.
  if (layout?.length)
    return <GroupedOtherBets bets={bets} match={match} isLive />;
  return (
    <>
      {bets.length > 8 &&
        (searchOpen ? (
          <MarketSearch
            value={query}
            onChange={setQuery}
            found={found.length}
            onClose={() => setSearchOpen(false)}
          />
        ) : (
          <div className={styles.bar}>
            <MarketSearchToggle onClick={() => setSearchOpen(true)} />
          </div>
        ))}
      {found.length ? (
        <OtherBets bets={found} match={match} isLive />
      ) : (
        <MarketSearchEmpty query={query} />
      )}
    </>
  );
};
